import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api/layouts`,
  timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 10000
});

export const getLayoutPage = async (page, limit) => {
  const response = await api.get('/', { params: { page, limit } });
  return response.data;
};

export const getLayoutById = async (id) => {
  const response = await api.get(`/${id}`);
  return response.data;
};

export const createLayout = async (formData) => {
  const response = await api.post('/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const updateLayout = async (id, formData) => {
  const response = await api.put(`/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const deleteLayout = async (id) => {
  const response = await api.delete(`/${id}`);
  return response.data;
};

export const changeMode = async (id, mode) => {
  console.log(`Changing mode for layout ${id} to ${mode}`);
  const response = await api.post(`/${id}/change-mode`, { mode });
  return response.data;
};

// Blinking schedule APIs
export const setBlinkingSchedule = async (layoutId, from, to) => {
  const response = await api.post(`/${layoutId}/blinking-schedule`, { from, to });
  return response.data;
};

export const clearBlinkingSchedule = async (layoutId) => {
  const response = await api.delete(`/${layoutId}/blinking-schedule`);
  return response.data;
};

export const getBlinkingSchedule = async (layoutId) => {
  const response = await api.get(`/${layoutId}/blinking-schedule`);
  return response.data.blinking[0];
};
